(function () {
  'use strict';

  var module = angular.module('wsLrs.controllers');
  module.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/dashboard/:boardId', {
      templateUrl: 'modules/app/card-group/card-group.html',
      controller: 'dashboard-ctrl',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).controller('dashboard-ctrl', ['$scope', '$uibModal', '$routeParams', '$timeout', 'CardGroup', 'DefaultCardGroups', 'DefaultCardGroupControl', 'Demo', 'CardDisplay', 'Interactions', 'User', 'UserRoles', 'ShareNav', 'Dashboards', '$rootScope', 'OrganizationSettings', '$location', 'AppPermissions', 'ViewDashboardsAs', 'QuickFilters', 'Utils', 'UserPreferences', function ($scope, $uibModal, $routeParams, $timeout, CardGroup, DefaultCardGroups, DefaultCardGroupControl, Demo, CardDisplay, Interactions, User, UserRoles, ShareNav, Dashboards, $rootScope, OrganizationSettings, $location, AppPermissions, ViewDashboardsAs, QuickFilters, Utils, UserPreferences) {
    $scope.boardId = $routeParams.boardId || "default";
    var isDefaultGroup = $scope.boardId === "default",
      isYourCardsGroup = $scope.boardId === "your-cards",
      isDemoDashboard = $scope.boardId === 'demo';
    function displayCards() {
      var dashboard = $scope.dashboard;
      function postFunction(foundAnyCards) {
        $scope.foundAnyCards = foundAnyCards;
        if ($scope.hasDashFilters) {
          if ($location.search().filter) {
            QuickFilters.setDashboardFilter($scope.cardGroup.id, JSON.parse($location.search().filter));
          } else {
            var filter = QuickFilters.getDashboardFilter($scope.cardGroup.id);
            if (filter) {
              $location.search("filter", JSON.stringify(filter));
            }
          }
        }
      }
      if ($scope.boardId === "your-cards") {
        CardDisplay.displayTopLevel($scope, dashboard).then(postFunction);
      } else if (dashboard.name === "Dashboard") {
        CardDisplay.displayTopLevel($scope, dashboard).then(postFunction);
      } else {
        CardDisplay.displayCards($scope, dashboard).then(postFunction);
      }
    }
    DefaultCardGroups.ensureExist().then(function (defaultCardGroups) {
      return Dashboards.get().then(function (dashboards) {
        // Dashboard may not be permitted even though it's defined as a default card group.
        // Always allow "your" cards, but ensure others are contained in the permitted map that
        // we got from Dashboards.get()
        _.each(defaultCardGroups, function (group) {
          var normalizedName = group.name.toLowerCase();
          if (normalizedName.indexOf("your") !== -1 || normalizedName === 'watershed demo' || dashboards[group.name]) {
            dashboards[group.name] = group;
          }
        });
        return dashboards;
      });
    }).then(function (groupMap) {
      var dashboard,
        user = User.get();
      if (isDefaultGroup) {
        dashboard = _.findWhere(_.values(groupMap), {
          id: user.membership.defaultDashboardId
        });
      } else if (isYourCardsGroup) {
        dashboard = groupMap["Your Reports"];
      } else if (isDemoDashboard) {
        dashboard = groupMap["Watershed Demo"];
      } else {
        dashboard = _.findWhere(_.values(groupMap), {
          id: parseInt($scope.boardId)
        });
      }
      if (!dashboard) {
        dashboard = groupMap["Your Reports"];
      }
      $scope.dashboard = dashboard;
      $scope.referenceId = dashboard.id;
      Demo.setDemoMode(isDemoDashboard);

      // Send essentials users back to essentials if need be
      if (!isDemoDashboard && OrganizationSettings.getCachedPricingTier() === 'ESSENTIALS') {
        $location.path("/essentials");
      }
      $scope.$emit("headline:change", dashboard.name, true);
      $scope.$emit("headline:change", 'hide');
      $scope.$emit("nav:change", "dashboards");
      Dashboards.changeCurrentDashboard(dashboard);
      function postRemove(cardsLeft) {
        $scope.foundAnyCards = cardsLeft > 0;
      }
      function deleteCard(cardId) {
        DefaultCardGroupControl.deleteCard(dashboard, cardId).then(postRemove);
      }
      $scope.extraActions = [{
        exploreCard: DefaultCardGroupControl.exploreCard
      }, {
        advancedConfig: DefaultCardGroupControl.advancedConfig
      }, {
        shareCard: ShareNav.shareCard($scope).createShareModal
      }, {
        adoptCard: DefaultCardGroupControl.adoptCard
      }, {
        dashboards: _.partial(DefaultCardGroupControl.dashboards, $scope)
      }, {
        renameCard: DefaultCardGroupControl.renameCard
      }];
      var session = User.get(),
        isCardAdmin = UserRoles.isOrgAdmin(session) || UserRoles.isOrgManager(session);
      if (dashboard.name === "Your Reports" || isCardAdmin) {
        $scope.extraActions = ($scope.extraActions || []).concat([{
          groupCard: function groupCard(cardId) {
            CardDisplay.enterGroupingMode(cardId);
          }
        }]);
      }
      $scope.extraActions = ($scope.extraActions || []).concat([{
        deleteCard: deleteCard
      }]);
      _.extend($scope.filterCfg.quickFilters, dashboard.quickFilters);
      $scope.hasDashFilters = QuickFilters.hasAnyQuickFiltersEnabled($scope.filterCfg.quickFilters);
      $timeout(function () {
        displayCards();
      });
    });
    AppPermissions.getForUser({
      value: 'explorer'
    }).then(function (permissions) {
      $scope.exposeCreateCardLink = (permissions.length || UserRoles.isOrgAdmin(User.get())) && !ViewDashboardsAs.isActive && OrganizationSettings.hasFeature('basicExplorer');
    });
    $scope.dashConfig = {
      filter: {},
      quickFilters: {
        activities: {
          type: 'disabled'
        },
        verbs: {
          type: 'disabled'
        },
        people: {
          type: 'disabled'
        },
        dates: {
          type: 'disabled'
        }
      }
    };
    $scope.isListView = function isListView() {
      return UserPreferences.getPreference('listView', {
        alt: false
      });
    };
    $scope.toggleListView = function toggleListView() {
      var newValue = !$scope.isListView();
      UserPreferences.setPreference('listView', newValue);
      if (newValue === false) {
        displayCards();
      }
    };
    $scope.filterCfg = {
      scope: $scope,
      quickFilters: $scope.dashConfig.quickFilters
    };
    $scope.quickFilter = function () {
      $scope.filterCfg.showFilter = !$scope.filterCfg.showFilter;
    };
    $scope.shouldRenderQuickFilters = function () {
      return Utils._try(function () {
        return $scope.filterCfg && $scope.cardGroup.id && $scope.hasDashFilters;
      }, false);
    };
    $scope.explore = function () {
      $rootScope.$broadcast("explore-card");
    };
  }]);
})();
